<template>
  <header class="packages-overview-filters-header">

    <h3 class="packages-overview-filters-header__title">
      Verfijn resultaten
    </h3>

    <button @click="$emit('closeFilters')"
            class="packages-overview-filters-header__close"
    >
      <InlineSvg src="@/assets/images/icons/x.svg"
                  class="packages-overview-filters-header__close-icon" />
    </button>

  </header>
</template>

<script>
import InlineSvg from '@/components/UI/InlineSvg.vue';

export default {
  name: 'FiltersHeader',

  components: {
    InlineSvg,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/css/helpers/mixins/breakpoints';

  .packages-overview-filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-m);

    @include laptop-and-larger {
      display: none;
    }

    &__title {
      font-size: 21px;
      line-height: 1.2;
      margin: 0;
    }

    &__close {
      padding: 4px 6.5px;
      background-color: transparent;

      &-icon {
        display: block;
        height: 1em;
        color: var(--color-primary);
      }
    }
  }
</style>
